import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';

export type GetDownloadVideoURLRequest = {
	organization_id?: string;
	company_id?: string;
	file_id: string;
	original_name?: string;
	created_at?: string;
};

async function getDownloadVideoURL(payload: GetDownloadVideoURLRequest) {
	const url = '/upload/create-url-download';
	const { data } = await Api.post<string>(url, payload);
	return data;
}

export const useGetDownloadVideoURL = ({
	organization_id,
	company_id,
	file_id,
	original_name
}: GetDownloadVideoURLRequest) => {
	const parameters = { organization_id, company_id, file_id, original_name };
	return useQuery(['download_video_url', parameters], () => getDownloadVideoURL(parameters), {
		enabled: !!organization_id && !!company_id && !!file_id && !!original_name
	});
};
